const countrySelectorModal = document.getElementById('countrySelectorModal');
const countrySelectorForm = document.getElementById('countrySelectorModalForm');
const currentCountryCode = countrySelectorModal.getAttribute('data-country');

/** Function to handle the countrySelector submit
 * @param  {SubmitEvent} e - SubmitEvent from the countrySelector form
 */
function handleCountrySelectorSubmit(e) {
    e.preventDefault();
    const selectedOption = document.querySelector('.country-selector-modal-select-js').value;
    let formAction = countrySelectorForm.getAttribute('action');
    /* Initially the default country code is set in the formAction
     * In this replace we change the 2 chars of the default country code with the selectedOption code
    */
    formAction = formAction.replace(/country=[a-z]{2}/gi, `country=${selectedOption}`);
    countrySelectorForm.setAttribute('action', formAction);

    // We set current site´s cookie and then hide the pop up
    fetch(formAction).then(() => {
        countrySelectorModal.classList.remove('country-selector-modal--show');
        if (selectedOption && selectedOption.toLowerCase() !== currentCountryCode.toLowerCase()) {
            window.location.reload();
        }
        countrySelectorForm.removeEventListener('submit', handleCountrySelectorSubmit);
    });
}

/** Initializing function
 */
function init() {
    // Show country selector modal
    countrySelectorModal.classList.add('country-selector-modal--show');

    if (countrySelectorForm) {
        countrySelectorForm.addEventListener('submit', handleCountrySelectorSubmit);
    }
}

// Init
window.addEventListener('DOMContentLoaded', init, false);
